<div class="min-h-screen bg-gray-900">
  <div class="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
    <div class="bg-gray-800 shadow-lg rounded-lg border border-gray-700">
      <div class="px-4 py-5 sm:p-6">
        <div class="sm:flex sm:items-center">
          <div class="sm:flex-auto">
            <h1 class="text-xl font-semibold text-white">User Management</h1>
            <p class="mt-2 text-sm text-gray-400">Manage user roles and permissions for the CMS.</p>
          </div>
        </div>

        <!-- Role Tabs -->
        <div class="mt-6 border-b border-gray-700">
          <nav class="-mb-px flex space-x-8" aria-label="Roles">
            <button *ngFor="let role of roles"
              (click)="currentRole = role"
              [class]="currentRole === role ? 
                'border-indigo-500 text-indigo-300 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium' : 
                'border-transparent text-gray-400 hover:border-gray-300 hover:text-gray-300 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium'"
            >
              <span class="capitalize">{{role}}s</span>
              <span class="ml-2 rounded-full bg-gray-700 px-2.5 py-0.5 text-xs font-medium text-gray-300">
                {{getUsersByRole(role).length}}
              </span>
            </button>
            <button
              (click)="currentRole = 'none'"
              [class]="currentRole === 'none' ? 
                'border-indigo-500 text-indigo-300 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium' : 
                'border-transparent text-gray-400 hover:border-gray-300 hover:text-gray-300 whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium'"
            >
              No Roles
              <span class="ml-2 rounded-full bg-gray-700 px-2.5 py-0.5 text-xs font-medium text-gray-300">
                {{getUsersWithoutRoles().length}}
              </span>
            </button>
          </nav>
        </div>

        <!-- Users Table -->
        <div class="mt-6 flow-root">
          <div class="-mx-4 -my-2 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div class="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <table class="min-w-full divide-y divide-gray-700">
                <thead>
                  <tr>
                   
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-300">Email</th>
                    <th *ngIf="currentRole !== 'none'" scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-300">Current Roles</th>
                    <th scope="col" class="px-3 py-3.5 text-left text-sm font-semibold text-gray-300">Actions</th>
                  </tr>
                </thead>
                <tbody class="divide-y divide-gray-700">
                  <tr *ngFor="let user of (currentRole === 'none' ? getUsersWithoutRoles() : getUsersByRole(currentRole))">
                   
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-300">{{user.email}}</td>
                    <td *ngIf="currentRole !== 'none'" class="whitespace-nowrap px-3 py-4 text-sm text-gray-300">
                      <div class="flex flex-wrap gap-2">
                        <span *ngFor="let role of getUserRoles(user)" 
                              class="inline-flex items-center rounded-md bg-indigo-900/50 px-2 py-1 text-xs font-medium text-indigo-300 ring-1 ring-inset ring-indigo-700">
                          {{role}}
                          <button (click)="removeUserRole(user.id, role)" 
                                  [disabled]="user.email === 'mvangastel@gmail.com' && role === 'superadmin'"
                                  [class]="user.email === 'mvangastel@gmail.com' && role === 'superadmin' ? 
                                           'ml-1 text-gray-500 cursor-not-allowed' : 
                                           'ml-1 text-indigo-300 hover:text-indigo-100'"
                          >
                            ×
                          </button>
                        </span>
                      </div>
                    </td>
                    <td class="whitespace-nowrap px-3 py-4 text-sm text-gray-300">
                      <select #roleSelect 
                              (change)="updateUserRole(user.id, roleSelect.value); roleSelect.value=''"
                              class="block w-full rounded-md border-0 bg-gray-700 py-1.5 pl-3 pr-10 text-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6">
                        <option value="" class="bg-gray-700">Add role...</option>
                        <option *ngFor="let role of roles" 
                                [value]="role" 
                                class="bg-gray-700">
                          {{role}}
                        </option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<app-notification></app-notification> 